import React from 'react';
import { Container, Row } from 'react-bootstrap';
import { FooterItems } from './FooterItems';
import {
    Bar,
    Foot, FooterA, FooterCenterCol, FooterCopyright, FooterLink, FooterLogo,
    FooterMenu
} from './StyledFooter';

const Footer = () => {
    return (
        <Foot>
            <Container>
                <Row>
                    <FooterCenterCol>
                        <FooterLogo to="/">
                            {/* <img src={AlignDx} style={{ width: '150px', height: 'auto' }} alt="AlignDx" /> */}
                            ANNOVIEW
                        </FooterLogo>
                    </FooterCenterCol>
                </Row>
                <Row>
                    <FooterCenterCol>
                        <FooterMenu>
                            {FooterItems.map((items, index) => (
                                <span key={index}>
                                    <FooterLink to={items.url}>{items.title}</FooterLink>
                                    <Bar />
                                </span>
                            ))}
                            <FooterA href="https://doxey.uwaterloo.ca/" target="_blank">Doxey Lab</FooterA>
                        </FooterMenu>
                    </FooterCenterCol>
                </Row>
                <Row>
                    <FooterCenterCol>
                        <FooterCopyright>
                            Copyright © Doxey Lab 2025, University of Waterloo Department of Biology. All rights reserved.
                        </FooterCopyright>
                    </FooterCenterCol>
                </Row>
            </Container>
        </Foot>
    )
}

export default Footer;